/*
 * @Author: 朱占伟
 * @LastEditors: 朱占伟
 * @description: 获取store
 * @Date: 2021-09-07 16:22:57
 * @LastEditTime: 2021-09-08 13:49:09
 */

//获取支付类型
const payTypes =  (state)=>{
  const list = state.payTypes
  return list
}
//获取支付说明信心
const payInfo =  (state)=>{
  const list = state.payInfo
  return list
}



export default {
  payTypes,payInfo
}